import styles from './SideNavLinks.module.scss';
import { VdsSidenavItem } from '@volt/volt-extended-components-react';
import { userHasPermission } from '@customer/permissions';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@customer/store/hooks';
import { NavLinkData } from '@customer/navigation';

interface SideNavLinksProps {
  isOpen: boolean;
  links: NavLinkData[];
}

export const SideNavLinks = ({ isOpen, links }: SideNavLinksProps) => {
  const { t } = useTranslation();

  const userData = useAppSelector(state => state.auth);

  const authorisedLinks = userData.isLoggedIn
    ? links.filter(link => userHasPermission(userData, link.permission))
    : [];

  return (
    <div className={styles.links}>
      {authorisedLinks.map(link => (
        <NavLink
          title={!isOpen ? t(link.titleKey) : undefined}
          to={link.to}
          key={link.key}
          style={{ textDecoration: 'none' }}
        >
          {({ isActive }) => (
            <VdsSidenavItem
              key={link.key}
              icon={link.icon}
              expanded={isOpen}
              value={t(link.titleKey)}
              isActive={isActive}
              hasChildren={true}
            />
          )}
        </NavLink>
      ))}
    </div>
  );
};

export default SideNavLinks;
